import { Component, OnInit } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { RestService } from 'src/app/services/rest/rest.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { Promotion } from 'src/app/interfaces/promocion';
import { environment } from 'src/environments/environment';
import { ProductList } from 'src/app/data/products';

@Component({
  selector: 'app-promotions',
  templateUrl: './promotions.page.html',
  styleUrls: ['./promotions.page.scss'],
})
export class PromotionsPage implements OnInit {
  selectedView = 'main';
  editFields = false;
  editedId: string;

  productField: string;
  nameField: string;
  ventaField: number;
  regaloField: number;
  notaField: string;

  productList: string[];

  columns = [
    {
      field: 'product',
      name: 'NOMBRE PRODUCTO',
      width: 25
    },
    {
      field: 'promotion',
      name: 'NOMBRE PROMOCIÓN',
      width: 25
    },
    {
      field: 'nota',
      name: 'Nota',
      width: 40
    },
    {
      field: 'action',
      name: 'acciones',
      width: 10,
      actions: [
        {
          type: 'delete'
        },
        {
          type: 'edit'
        }
      ]
    }
  ];

  lines: Promotion[];
  filteredLines: Promotion[];

  constructor(private alert: AlertController,
    private rest: RestService,
    private utils: UtilsService
  ) { }

  ngOnInit() {
    this.productList = ProductList;
    this.getPromitions();
  }

  changeView(view: string) {
    this.selectedView = view;
  }

  addNew() {
    this.selectedView = 'promotion';
    this.productField = '';
    this.nameField = '';
    this.ventaField = null;
    this.regaloField = null;
    this.notaField = '';


    this.editFields = false;
    console.log('addnew');
  }

  async getPromitions() {
    await this.utils.showLoading();
    const result: any = await this.rest.getPromotiones(1, 1000);
    this.lines = result.body.records;
    this.lines.forEach(item => {
      item.promotion = `${item.venta} - ${item.regalo}`;
    });
    this.filteredLines = this.lines;
    await this.utils.hideLoading();
  }

  async savePromotion() {
    const sendPromotion: Promotion = {
      product: this.productField,
      name: this.nameField,
      venta: this.ventaField,
      regalo: this.regaloField,
      nota: this.notaField
    };

    await this.utils.showLoading();
    const result = await this.rest.createPromotion(sendPromotion);
    console.log(result);
    if (result) {
      this.productField = '';
      this.nameField = '';
      this.ventaField = null;
      this.regaloField = null;
      this.notaField = '';
      this.selectedView = 'main';
      this.getPromitions();
    }
    await this.utils.hideLoading();
  }

  async editPromotion() {
    const sendPromotion: Promotion = {
      _id: this.editedId,
      product: this.productField,
      name: this.nameField,
      venta: this.ventaField,
      regalo: this.regaloField,
      nota: this.notaField
    };

    await this.utils.showLoading();
    const result = await this.rest.editPromotion(sendPromotion);
    console.log(result);
    if (result) {
      this.selectedView = 'main';
      this.getPromitions();
    }
    await this.utils.hideLoading();
  }

  async doAction(data) {
    console.log(data);
    const promotion: Promotion = data.line;
    if (data.action === 'delete') {
      this.deleteItem(promotion);
    }
    if (data.action === 'edit') {
      console.log('edit');
      this.selectedView = 'promotion';
      this.editedId = promotion._id;
      this.productField = promotion.product;
      this.nameField = promotion.name;
      this.ventaField = promotion.venta;
      this.regaloField = promotion.regalo;
      this.notaField = promotion.nota;
      this.editFields = true;
    }
  }

  async deleteItem(promotion: Promotion) {
    const alert = await this.alert.create({
      header: '¿Borrar?',
      message: 'Borrar promotion ' + promotion.name,
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          cssClass: 'secondary'
        }, {
          text: 'Sí',
          handler: async () => {
            console.log('Item to remove!!!');
            await this.utils.showLoading();
            await this.rest.deletePromotion(promotion._id);
            this.getPromitions();
            await this.utils.hideLoading();
          }
        }
      ]
    });
    await alert.present();
  }

  checkValidFields() {
    if (this.productField === '' ||
      this.nameField === '' ||
      this.ventaField < 1 ||
      this.regaloField < 1) {
      return true
    }
  }

  search(event: any) {
    this.filteredLines = this.lines;
    var filter = event.target.value;
    // Contains:
    var products = this.lines.map(product => product.product);
    products = products.filter(n => n.toLowerCase().includes(filter.toLowerCase()));
    this.filteredLines = this.filteredLines.filter(product => products.includes(product.product));
    // Starts with:
    // this.filteredLines = this.filteredLines.filter(product => product.product.toLowerCase().startsWith(filter));
  }
}
